import { getUlContext } from '@/utils/ulForm'

/**
 * As telas `reset-password-success` e `reset-password-error` não têm ação no
 * SDK do ACUL — só `screen.links`, o mesmo que `getScreenLinks` do SDK lê do
 * contexto. Fora do Universal Login (preview), não há contexto.
 */
export function readResultLinks(): {
  inUniversalLogin: boolean
  links: Record<string, string>
} {
  const ctx = getUlContext()
  return { inUniversalLogin: Boolean(ctx), links: ctx?.screen?.links ?? {} }
}

/** Primeira URL cuja chave casa com o padrão (ex.: `login`, `back`). */
export function pickLink(
  links: Record<string, string>,
  pattern: RegExp,
): string | undefined {
  return Object.entries(links).find(([key, url]) => pattern.test(key) && Boolean(url))?.[1]
}
